import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/LocationsMap/LocationsMap.js
const LocationsMap = createSectionForm({
  icon: "map-2-line",
  title: "Locations Map",
  fields: [
    {
      name: "locations",
      label: "Locations",
      type: "list",
      itemLabel: "Location",
      fields: [
        { name: "image", label: "Map Image", type: "media" },
        { name: "name", label: "Name", placeholder: "OVIEDO, FLORIDA" },
        { name: "subtitle", label: "Subtitle", placeholder: "Headquarters" },
      ],
    },
  ],
});

export default LocationsMap;
